/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkFlowRuleListRequest {
    getFixupPrototypeFunction() { return WorkFlowRuleListRequest.fixupPrototype; }

    static newInstance(model: Partial<WorkFlowRuleListRequest>): WorkFlowRuleListRequest {
        let obj = Object.assign(new WorkFlowRuleListRequest(), model);
        WorkFlowRuleListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkFlowRuleListRequest>): WorkFlowRuleListRequest {
        if (!model) return null;
        return WorkFlowRuleListRequest.newInstance(<WorkFlowRuleListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkFlowRuleListRequest) {
        if (!obj) return;

        models.WorkFlowRuleListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkFlowRuleListRequest): boolean {
        Object.setPrototypeOf(obj, WorkFlowRuleListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * SubCategory for which the workflow which has to be generated.
     */
    category: models.WorkFlowCategory;

    /**
     * Sys Id of the tenant account where the workflow belongs to
     */
    tenant_id: string;

    /**
     * workflow sys id for which the rules are required
     */
    workflow_sys_id: string;

}
